module.exports = __webpack_public_path__ + "static/media/flat-view-controls-selected-icon.f6300b76.svg";